import React, { useMemo } from 'react';
import { Col, SelectInput } from '../../../../landing.common';
import { Typography } from '@sravni/react-design-system';
import { Row } from '../../common';
import { Controller, UseFormReturn } from 'react-hook-form';
import { FORM_FIELDS } from '../../../../../constants';
import { RadioGroup } from '../../../ui/radio.group';

const { Heading } = Typography;

type Props = {
    form: UseFormReturn;
};

export const AdditionalQuestions: React.FC<Props> = (props) => {
    const { form } = props;
    const {
        control,
        formState: { errors, dirtyFields: _ },
        watch,
    } = form;

    const [hasRecentApplication] = watch([FORM_FIELDS.HAS_RECENT_APPLICATION]);

    const hasRecentApplicationOptions = useMemo(
        () => [
            { value: 'Да', label: 'Да' },
            { value: 'Нет', label: 'Нет' },
        ],
        [],
    );

    const recentApplicationCauseOptions = useMemo(
        () => [
            { value: 'Был отказ по заявке', label: 'Был отказ по заявке' },
            { value: 'Не подошли условия', label: 'Не подошли условия' },
            { value: 'Взял кредит', label: 'Взял кредит' },
        ],
        [],
    );

    return (
        <>
            <Row>
                <Col>
                    <Heading level={4}>Информация по прошлым заявкам</Heading>
                </Col>
            </Row>
            <Row>
                <Col md-8>
                    <Controller
                        control={control}
                        name={FORM_FIELDS.HAS_RECENT_APPLICATION}
                        render={({ field }) => (
                            <SelectInput
                                {...field}
                                label="Подавали заявку на кредит в течение месяца?"
                                options={hasRecentApplicationOptions}
                                errorMessage={errors[FORM_FIELDS.HAS_RECENT_APPLICATION]?.message}
                                withCrossIcon={false}
                            />
                        )}
                    />
                </Col>
            </Row>
            {hasRecentApplication === 'Да' && (
                <Row>
                    <Col md-4>
                        <Controller
                            control={control}
                            name={FORM_FIELDS.RECENT_APPLICATION_CAUSE}
                            render={({ field }) => (
                                <RadioGroup
                                    list={recentApplicationCauseOptions}
                                    {...field}
                                    errorMessage={errors[FORM_FIELDS.RECENT_APPLICATION_CAUSE]?.message}
                                />
                            )}
                        />
                    </Col>
                </Row>
            )}
        </>
    );
};
